module.exports = __webpack_public_path__ + "img/default_poster.b40f6c83.png";